import gql from 'graphql-tag';
import { City, Area } from './types';



// ____________ Start Queries ___________________

// Categories gql
export const Categories =  gql `
  query categories {
    categories (order_by: [{priority: asc_nulls_last}])  {
      id
      name_ar
      name_en
      items_categories(order_by: {item: {priority: asc_nulls_last}}){
          item {
              id
              img_url
              name_ar
              name_en
              description_ar
              description_en
              price
          attributes (order_by:{priority:asc}) {
            description_ar
            description_en
            id
            item_id
            max
            min
            group_name
            name_ar
            name_en
            priority
            type
            attributes_options {
              attribute_id
              option_id
              option {
                description_ar
                description_en
                id
                name_ar
                name_en
                price
              }
            }
          }
        }
      }
    }
  }
`;


// most selling gql
export const MostSellings =  gql `
  query mostSellings {
    mostSellings : items(order_by: [{order_items_aggregate: {sum: {quantity: desc_nulls_last}}}], limit: 5)  {
        id
        img_url
        name_ar
        name_en
        description_ar
        description_en
        price
        order_items_aggregate {
            aggregate {
                sum {
                    quantity
                }
            }
        }
        attributes (order_by:{priority:asc}) {
          description_ar
          description_en
          id
          item_id
          max
          min
          group_name
          name_ar
          name_en
          priority
          type
          attributes_options {
            attribute_id
            option_id
            option {
              description_ar
              description_en
              id
              name_ar
              name_en
              price
            }
          }
        }
    }
  }
`;

 
// get my orders
export const myOrders =  gql `
  query myOrders {
    orders(order_by: {created_at:desc_nulls_last}){
      id
      created_at
      payment
      order_number
      status
      summary
      address{
        id
        area{
          name_ar
          name_en
        }
        city{
          name_ar
          name_en
        }
        apartment
        block
        building
        floor
        landmark
      }
    }
  }
`;


// order details
export const orderDetails =  gql `
  query order($id:uuid!){
    orders_by_pk(id:$id){
      summary
    }
  }
`;



// current Users Name And Email gql
export const UsersMainInfo =  gql `
  query users {
    users{
      id
      name
      email
      mobile 
      points
      card_tokens
    }
  }
`;

// current Users Name And Email gql
// export const UsersName =  gql `
//   query users {
//     users{
//       id
//       name
//     }
//   }
// `;



// export const UsersMainInfo =  gql `
//   query users {
//     users{
//       id
//       name
//       email
//       gender
//       date_of_birth
//       addresses{
//         id
//         apartment
//         block
//         building
//         floor
//         landmark
//         city{
//           name_ar
//           name_en
//         }
//         area{
//           name_ar
//           name_en
//         }
//       }
//     }
//   }
// `;



// Sider gql
export const Slides =  gql `
    query slides {
      slides {
        id
        img_url
        name_ar
        name_en
        priority
      }
    }
`;


// Sider details gql
export const Slidedetails =  gql `
  query slidedetails($sliderId: uuid!) {
    items(order_by: {price: asc_nulls_last}, where: {slides_items: {slide_id: {_eq: $sliderId}}}) {
      id
      name_ar
      name_en
      description_ar
      description_en
      price
      img_url
      order_items_aggregate {
          aggregate {
              sum {
                  quantity
              }
          }
      }
      attributes (order_by:{priority:asc}) {
        description_ar
        description_en
        id
        item_id
        max
        min
        group_name
        name_ar
        name_en
        priority
        type
        attributes_options {
          attribute_id
          option_id
          option {
            description_ar
            description_en
            id
            name_ar
            name_en
            price
          }
        }
      }
    }
  }
`;



// Branches gql O_o
export const Branches =  gql `
  query branches {
    branches {
      id
      name_ar
      name_en
      location
      opening
      closing
      address
      mobile
      city{
        name_ar
        name_en
      }
    }
  }
`;


// Branches gql O_o
export const BrancheDetails =  gql `
  query branchedetails($id:uuid!){
    branches_by_pk(id:$id){
    id
    mobile
    address
    closing
    opening
    name_ar
    name_en
    location
    }
  }
`;



// vacancies gql
export const vacancies =  gql `
  query{
    vacancies(where: {visible:{_eq:true}}){
      id
      name_ar
      name_en
    }
  }
`;


// Cities gql
export const Cities =  gql `
  query cities {
    cities(order_by:{name_en:asc_nulls_last}) {
      id
      name_ar
      name_en
      areas(order_by:{name_en:asc_nulls_last}) {
        city_id
        estimate_time
        fee
        id
        name_ar
        name_en
      }
    }
  }
`;


// Cities ar gql
export const CitiesAr =  gql `
  query cities {
    cities(order_by:{name_ar:asc_nulls_last}) {
      id
      name_ar
      name_en
      areas(order_by:{name_ar:asc_nulls_last}) {
        city_id
        estimate_time
        fee
        id
        name_ar
        name_en
      }
    }
  }
`;


// area_streets gql
export const area_streets =  gql `
  query area_streets {
    area_streets(order_by: {name_en: asc_nulls_last}) {
      id
      name_ar
      name_en
      area_id
    }
  }
`;


// area_streets gql
export const area_streets_ar =  gql `
  query area_streets {
    area_streets(order_by: {name_ar: asc_nulls_last}) {
      id
      name_ar
      name_en
      area_id
    }
  }
`;



// checkMobile gql
export const checkMobile =  gql `
  query checkMobile($mobile:String!){
    users(where:{mobile:{_eq:$mobile}}){
      mobile
    }
  }
`;


// settings gql
export const settings =  gql `
  query settings {
    settings{
      closing
      opening
      loyalty_point_per_money
    }
  }
`;


// Address query
export const Addresses =  gql `
  query addresses {
    addresses{
        id
        apartment
        block
        building
        floor
        landmark
        street {
          id
          name_ar
          name_en
        }
        type
        city{
          id
          name_ar
          name_en
        }
        area {
          id
          name_ar
          name_en
          fee
          estimate_time
        }
      }
  }
`;


// promo code
export const GetPromoCode =  gql `
  query GetPromoCode($date: date!, $promocode:String){
    promocodes(where: {_and: {expire_at: {_gte: $date}, code: {_eq:$promocode}, disabled:{_eq: false}}}) {
      type
      discount
    }
    orders(where:{promocode_id:{_eq: $promocode}}) {
      user_id
    }
  }
`;


// Get Item Details gql O_o
export const GetItemDetails =  gql `
  query GetItemDetails($itemId: uuid!){
    attributes(where:{item_id:{_eq: $itemId}}){
      id
      name_ar
      name_en
      description_ar
      description_en
      min
      max
      type
      attributes_options{
        option{
          id
          name_ar
          name_en
          description_ar
          description_en
          price
        }
      }
    }
  }
`;




// Get Item Details gql O_o
export const ItemDetails =  gql `
  query ItemDetails($id: uuid!) {
    items_by_pk(id: $id) {
        id,
        img_url,
        price,
        description_ar,
        description_en,
        name_en,
        name_ar,
        description_ar,
        description_en,
        attributes (order_by:{priority:asc}){
            id,
            item_id,
            name_ar,
            name_en,
            type,
            min,
            max,
            group_name,
            priority
        }
  }
}
`;








// Get Item Details gql O_o
export const GetOrderSummary =  gql `
  query order($id:uuid!){
    orders_by_pk(id:$id){
      card_token
      payment
      total
    	promocodeDiscount
      walletDiscount
      summary
      order_number
      status
      address {
        id
        type
        area {
          name_en
          name_ar
          estimate_time
          fee
        }
        city {
          name_en
          name_ar
        }
        street{
          name_en
          name_ar
        }
      }
    }
  }
`;




// ____________ InsertUser Generate Code ________
export const GenerateCode = gql`
  mutation GenerateCode($mobile: String!){
    generateVerificationCode(mobile: $mobile){
        success
    }
  }
`;

//3
export interface GenerateCodeMutationResponse {
  mobile: any;
  generateVerificationCode: any
}


// update user name
export const UpdateUser = gql`
  mutation UpdateUser($user:users_set_input!, $id: String!){
    update_users_by_pk(pk_columns:{id:$id}, _set:$user){
      id
      name
      mobile
    }
  }
`;

//3
export interface UpdateUserMutationResponse {
  id: string
  name: string
  mobile: string
}



export const VerifyCode = gql`
  mutation VerifyCode($code: String!){
    verifySmsCode(code: $code){
        validCode
    }
  }
`;

//3
export interface VerifyCodeMutationResponse {
  code: any;
  verifySmsCode: any;
}




// ____________ Insert User mutation ________
export const InsertUser = gql`  
  mutation insertUser($email:String!, $mobile:String!, $date_of_birth:date!, $gender:Boolean!, $name:String!){
    insert_users_one(object:{
      email:$email,
      mobile:$mobile,
      date_of_birth:$date_of_birth,
      gender:$gender,
      name:$name,
    }){
      id
      name
      mobile
      gender
    }
  }
`;


export interface InsertUserMutationResponse {
  name: string,
  email: string,
  mobile: string,
  date_of_birth: string,
  gender: boolean
}








// ____________ Insert Address mutation ________
export const InsertAddress = gql `
  mutation InsertAddress($data: addresses_insert_input!) {
    insert_addresses_one(object: $data) {
      id
      type
      apartment
      block
      building
      floor
      landmark
      city {
        name_ar
        name_en
      }
      area {
        name_ar
        name_en
        fee
        estimate_time
      }
    }
  }
`;

export interface InsertAddressMutationResponse {
    id: string,
    type: string
    apartment: string
    block: string
    building: string
    floor: string
    landmark: string
    city: City
    area: Area
}





// ____________ Update Address mutation ________
export const UpdateAddress = gql `
  mutation UpdateAddress($data: addresses_set_input!, $id: uuid!) {
    update_addresses_by_pk(_set: $data, pk_columns: {id: $id}) {
        id
        apartment
        block
        building
        floor
        landmark
        street {
          id
          name_ar
          name_en
        }
        city {
          id
          name_ar
          name_en
        }
        area {
          id
          name_ar
          name_en
          fee
          estimate_time
        }
    }
  }
`;

export interface UpdateAddressMutationResponse {
  // id: string,
  // type: string
  apartment: string
  block: string
  building: string
  floor: string
  landmark: string
  city: City
  area: Area

}




// ____________ send complaint mutation ________
export const cancelOrder = gql `
  mutation cancelOrder($id:uuid!) {
    update_orders_by_pk(pk_columns:{id:$id}, _set:{status:CANCELED}){
      id
      status
    }
  }
`;

export interface cancelOrderMutationResponse {
  id: string,
  status: string
} 


// ____________ send complaint mutation ________
export const insertComplaint = gql `
  mutation insertComplaint($complaint: complaints_insert_input!){
    insert_complaints_one(object:$complaint) {
      id
      text
    }
  }
`;

export interface insertComplaintMutationResponse {
  id: string,
  text: string
} 



// ____________ create order mutation ________
export const createOrder = gql `
  mutation createOrder($order:OrderInput!) {
    createOrder(order:$order){
      id
    }
  }
`;

export interface createOrderMutationResponse {
  id: string
  orders: any;
  createOrder: any
} 




// ____________ InsertCareer ________
export const InsertCareer = gql`
  mutation InsertCareer($data:careers_insert_input!) {
    insert_careers_one(object:$data){
      id
      name
      email
      cv_url
      vacancy_id
    }
  }
`;

//3
export interface InsertCareerMutationResponse {
  id: string
  name: string
  email: string
  cv_url: string
  vacancy_id: string
}





// ____________ add card  ________
export const AddCard = gql `
  mutation addCard($nameOnCard: String!, $month: String!, $year: String!, $securityCode: String!, $number: String!){
    addCard(nameOnCard: $nameOnCard, month: $month, year: $year, securityCode: $securityCode, number: $number){
        token
    }
  }
`;

//3
export interface AddCardMutationResponse {
  card_tokens: string
}




// ____________ delete card  ________
export const deleteCard = gql `
  mutation deleteCard($cardToken: String!){
    deleteCard(cardToken: $cardToken){
        message
    }
  }
`;

//3
export interface DeleteCardMutationResponse {
  message: string
}

// ____________ end Queries ___________________